<template>
  <v-app
    :class="{ 'pattern-bg': light, 'pattern-bg-dark': dark }"
    v-if="!loading"
  >
    <v-navigation-drawer
      v-if="menu != 'none'"
      v-model="drawer"
      v-resize="onResize"
      :mini-variant.sync="mini"
      :expand-on-hover="$vuetify.breakpoint.mdAndUp"
      class="elevation-2"
      app
      clipped
    >
      <v-scroll-x-reverse-transition group hide-on-leave>
        <MenuDashBoardCliente :key="0" v-if="menu === 'dashboard'" />
      </v-scroll-x-reverse-transition>
    </v-navigation-drawer>

    <v-app-bar
      class="elevation-2"
      :class="{ primary: light, 'panel-gradient-bg-dark': dark }"
      app
      clipped-left
      dark
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        @click:outside="drawer = !drawer"
        @keydown.esc="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <h4 class="text-h6">CLIENTE</h4>
      <v-spacer></v-spacer>
      <v-btn v-if="isAdmin" class="mx-5" icon :to="{ path: '/admin/home' }">
        <v-icon> mdi-shield-account </v-icon>
      </v-btn>
      <!-- Desativado ao pedido do cliente -->
      <!-- <v-badge
        class="mr-5"
        :content="count_notificacao"
        :value="count_notificacao"
        color="green"
        overlap
      >
        <v-btn small icon @click="toGoNotificacao">
          <v-icon>
            mdi-bell
          </v-icon>
        </v-btn>
      </v-badge> -->
      <div class="d-flex justify-center align-center mr-3">
        <v-avatar size="50">
          <v-img
            contain
            :src="
              store_avatar
                ? store_avatar
                : require('@/assets/avatar_placeholder.png')
            "
          >
          </v-img>
        </v-avatar>

        <div class="ml-2 text-body-1">{{ usuario_name.name }}</div>
      </div>

      <v-btn dark icon @click="menuUsuario = !menuUsuario">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </v-app-bar>

    <MenuLateralDireitoCliente
      v-if="menuUsuario"
      :menuUsuario.sync="menuUsuario"
    />

    <v-main style="z-index: 1">
      <transition mode="out-in">
        <router-view />
      </transition>
    </v-main>
    <v-footer
      height="30px"
      app
      inset
      dark
      class="elevation-2"
      :class="{ primary: light, 'panel-gradient-bg-dark': dark }"
    >
    </v-footer>

    <v-card
      tile
      flat
      width="150px"
      height="150px"
      style="background: #eeeeee; position: fixed; right: 1px; bottom: -6px"
    >
      <v-img contain :src="logo ? logo : ''"></v-img>
    </v-card>
  </v-app>
  <v-app v-else>
    <v-main>
      <v-container class="fill-height align-center justify-center">
        <v-progress-circular
          :width="5"
          indeterminate
          :color="dark ? 'white' : 'primary'"
          size="80"
        ></v-progress-circular>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { format } from "date-fns";
import { fetchEmpresa } from "@/api/cliente/cliente_empresa.js";

export default {
  name: "ClienteLayout",
  components: {
    MenuLateralDireitoCliente: () =>
      import("./components/MenuLateralDireitoCliente.vue"),
    MenuDashBoardCliente: () => import("./menus/MenuDashBoardCliente.vue"),
  },
  data() {
    return {
      drawer: true,
      mini: true,
      menuUsuario: false,
      locale: "",
      windowSize: {
        x: 0,
        y: 0,
      },
      apiUrl: null,
      dialogProfile: false,
      menu: "",
      loading: false,
      logo: null,
    };
  },

  computed: {
    ...mapState("Notificacoes", {
      count_notificacao: (state) => state.count_notificacao,
    }),
    year() {
      return format(new Date(), "yyyy");
    },
    ...mapState({
      light: (state) => state.template.light,
      dark: (state) => state.template.dark,
    }),
    ...mapGetters("Usuario", ["isAdmin", "isCliente"]),
    ...mapState("Usuario", {
      usuario_name: (state) => state.user_name,
      store_avatar: (state) => state.avatar,
      user_id: (state) => state.usuario.id,
    }),
    nome() {
      let splitName = this.usuario_name.split(/ /);
      let firstName = splitName[0] ? splitName[0] : "";
      let lastName = splitName[1] ? splitName[1] : "";
      firstName =
        firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
      lastName =
        lastName.charAt(0).toUpperCase() + lastName.slice(1).toLowerCase();
      let name = firstName + " " + lastName;
      return name;
    },
  },

  watch: {
    $route() {
      if (this.$route.meta.menu) {
        this.menu = this.$route.meta.menu;
      }
    },
  },

  methods: {
    getCliente() {
      this.loading = true;
      return fetchEmpresa(this.user_id)
        .then((response) => {
          this.logo = response.logo;
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
    ...mapActions("Notificacoes", {
      STORE_count: "count",
    }),
    toGoNotificacao() {
      this.$router.push("/cliente/notificacoes");
    },
    openDialogShow() {
      this.dialogProfile = true;
    },
    deslogarUsuario() {
      this.loading = true;
      this.$store.dispatch("Usuario/deslogarUsuario").then(() => {
        this.$router.push("/login");
        this.loading = false;
      });
    },
    setTemplate() {
      if (this.light) {
        this.$store.commit("UPDATE_TEMPLATE", { dark: true, light: false });
        this.$ls.set("template", "dark");
        this.$vuetify.theme.dark = true;
      } else {
        this.$store.commit("UPDATE_TEMPLATE", { dark: false, light: true });
        this.$ls.set("template", "light");
        this.$vuetify.theme.dark = false;
      }
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      if (this.windowSize.x < 1264) {
        return (this.mini = false);
      }
    },
  },
  async mounted() {
    if (this.isCliente) {
      await this.getCliente();
    }

    this.STORE_count();
    if (this.$route.meta.menu) {
      this.menu = this.$route.meta.menu;
    } else {
      this.menu = "dashboard";
    }
    if (process.env.VUE_APP_API_URL) {
      this.apiUrl = process.env.VUE_APP_API_URL;
    }

    this.onResize();
    this.locale = this.$i18n.locale;
  },
};
</script>

<style lang="scss" scoped>
.pattern-bg {
  background-color: #eeeeee !important;
}

.pattern-bg-dark {
  background-color: #3a3a3a !important;
}

.v-enter,
.v-leave-to {
  transform: translate3d(-20px, 0, 0);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
